import { render, staticRenderFns } from "./ListBrands.vue?vue&type=template&id=ad3b4a94&"
import script from "./ListBrands.vue?vue&type=script&lang=js&"
export * from "./ListBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports